define('services/CancellationService',['app', 'modules/module', 'services/EntityCrudService'], function (app, module) {
	'use strict';
	return module.factory('CancellationService', [
		'$injector',
		function ($injector) {
			var crudInstance = $injector.instantiate(CrudService);
			crudInstance.setType('Cancellation');
			angular.extend(this, crudInstance);

			this.create = function (cancellation) {
				return new $injector.get('ModelFactory').Cancellation().create(cancellation).$promise;
			};

			this.delete = function (cancellationId) {
				return new $injector.get('ModelFactory').Cancellation().delete({ id: cancellationId }).$promise;
			};

			this.findByShopOrderId = function (shopOrderId) {
				return new $injector.get('ModelFactory').Cancellation().findByShopOrderId({ id: shopOrderId }).$promise;
			};

			/**
			 * Führt eine Stornierung für die gesamte Bestellung direkt aus
			 * @param {number} shopOrderId - ID der zu stornierenden Bestellung
			 * @param {object} options - Optionale Parameter für die Stornierung
			 * @returns {Promise} Promise mit CancellationDTO
			 */
			this.executeOrderCancellation = function (shopOrderId, options) {
				var params = {
					id: shopOrderId,
					reason: options && options.reason ? options.reason : 'CUSTOMER_REQUEST',
					handling: options && options.handling ? options.handling : 'REFUND',
					sendMailToCustomer: options && options.sendMailToCustomer !== undefined ? options.sendMailToCustomer : true,
					sendMailToAdmin: options && options.sendMailToAdmin !== undefined ? options.sendMailToAdmin : true,
					comment: options && options.comment ? options.comment : 'Stornierung durch Admin-Backend'
				};

				return new $injector.get('ModelFactory').Cancellation().executeOrderCancellation(params).$promise;
			};

			return this;
		},
	]);
});

